import { render, staticRenderFns } from "./ourStory.vue?vue&type=template&id=67332a41&scoped=true&"
import script from "./ourStory.vue?vue&type=script&lang=js&"
export * from "./ourStory.vue?vue&type=script&lang=js&"
import style0 from "./ourStory.vue?vue&type=style&index=0&id=67332a41&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67332a41",
  null
  
)

export default component.exports